import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./bringoz-capacity-bar.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-capacity-bar',
  templateUrl: './bringoz-capacity-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCapacityBarComponent implements OnInit, OnChanges {

  @Input() value: number;
  @Input() isDisableSeverity: boolean;
  @Input() showValue: boolean = false;
  @Input() unit: string = '';
  @Input() severityThresholds: { low: number; mid: number; } = { low: 80, mid: 99 };
  public severity: string; // low, mid, high

  constructor() {
  }

  ngOnInit() {
    this._setValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value && !changes.value.isFirstChange()) {
      this._setValue();
    }
  }

  private _setValue() {
    this.severity = (this.value <= this.severityThresholds.low) ? 'low' : ((this.value > this.severityThresholds.low && this.value < this.severityThresholds.mid) ? 'mid' : 'high');
  }
}
